"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductComparePrinter = void 0;
const jspdf_1 = require("jspdf");
const product_page_print_constants_1 = require("../constants/product-page-print-constants");
const product_compare_print_util_1 = require("../util/product-compare-print.util");
const rxjs_1 = require("rxjs");
class ProductComparePrinter {
    constructor(config) {
        this.config = config;
        this.PILLS_API_URL_V1 = `http://${this.config.assetsBaseUrl}/assets/images/pdf/`;
        this.LOGO_URL = `https://${this.config.assetsBaseUrl}/assets/images/usfoods-logo-print.jpg`;
        this.PRODUCT_ICON_URL = `https://${this.config.assetsBaseUrl}/assets/icon/restaurant.png`;
    }
    async createPDFBlob(printProductCompareModel) {
        const doc = new jspdf_1.default({
            orientation: "portrait",
            unit: "pt",
            format: "letter",
        });
        doc.setProperties({ title: printProductCompareModel?.fileName });
        doc.setLineHeightFactor(product_page_print_constants_1.TEXT_LINE_HEIGHT);
        const productStatusPillUrls = printProductCompareModel?.productStatusPills?.map((productStatusPills) => productStatusPills?.map((productStatusPill) => productStatusPill?.type === "url"
            ? productStatusPill?.path
            : `${this.PILLS_API_URL_V1}${productStatusPill?.path}`));
        const pathToImageMap = await this.getPathToImageDataMap([
            this.LOGO_URL,
            this.PRODUCT_ICON_URL,
            ...printProductCompareModel?.productImageUrls,
            ...productStatusPillUrls?.reduce((allPillUrls, currentPillUrls) => allPillUrls?.concat(currentPillUrls)),
        ]);
        this.createProductComparisonImagesTable(doc, printProductCompareModel?.productImageUrls, pathToImageMap);
        this.createProductComparisonTable(doc, printProductCompareModel, productStatusPillUrls, pathToImageMap);
        this.createHeaders(doc, printProductCompareModel?.documentHeaderTitle, pathToImageMap);
        this.createFooters(doc);
        return doc.output("blob");
    }
    createProductComparisonImagesTable(doc, productImages, pathToImageMap) {
        (0, product_compare_print_util_1.addProductComparisonImagesTable)(doc, productImages, pathToImageMap, this.PRODUCT_ICON_URL, product_page_print_constants_1.PAGE_MARGIN, product_page_print_constants_1.HEADER_HEIGHT);
    }
    createProductComparisonTable(doc, printProductCompareModel, productStatusPillUrls, pathToImageMap) {
        const imagesHeight = product_page_print_constants_1.PRODUCT_COMPARE_DIMENSIONS.productImageSize;
        (0, product_compare_print_util_1.addProductComparisonTable)(doc, printProductCompareModel?.includeProductPrices, printProductCompareModel?.rowLabels, printProductCompareModel?.productCompareDetails, productStatusPillUrls, pathToImageMap, product_page_print_constants_1.PAGE_MARGIN, product_page_print_constants_1.HEADER_HEIGHT + imagesHeight);
    }
    createHeaders(doc, documentHeader, pathToImageMap) {
        const pageCount = doc.getNumberOfPages();
        for (let pageNumber = 1; pageNumber <= pageCount; pageNumber++) {
            doc.setPage(pageNumber);
            (0, product_compare_print_util_1.addHeader)(doc, pathToImageMap?.get(this.LOGO_URL), documentHeader, product_page_print_constants_1.PAGE_MARGIN, product_page_print_constants_1.PAGE_MARGIN);
        }
    }
    createFooters(doc) {
        const pageCount = doc.getNumberOfPages();
        for (let pageNumber = 1; pageNumber <= pageCount; pageNumber++) {
            doc.setPage(pageNumber);
            (0, product_compare_print_util_1.addFooter)(doc, pageNumber, pageCount, 0, product_page_print_constants_1.PAGE_HEIGHT - product_page_print_constants_1.FOOTER_HEIGHT);
        }
    }
    async getPathToImageDataMap(imageUrls) {
        const imageUrlsSet = new Set(imageUrls);
        const uniqueImageUrls = Array.from(imageUrlsSet);
        const images = (await this.getImages(Array.from(uniqueImageUrls)))?.map((response) => response?.imageBase64);
        const pathToImageDataMap = new Map();
        for (let index = 0; index < uniqueImageUrls?.length; index++) {
            const path = uniqueImageUrls?.[index];
            if (index < images?.length) {
                const image = path?.split(".")?.pop() === "svg"
                    ? (await this.config.imageConverter.convertBase64SvgToPng(images?.[index]))?.pngImageBase64
                    : images?.[index];
                pathToImageDataMap.set(path, image);
            }
        }
        return pathToImageDataMap;
    }
    async getImages(imageUrls) {
        return (0, rxjs_1.firstValueFrom)(this.config.serviceHandler.post(this.config.imageBase64ApiUrl, imageUrls));
    }
}
exports.ProductComparePrinter = ProductComparePrinter;
